import React from 'react';
import SwitchButton from 'core/components/Switch';
import clsx from 'clsx';

type Props = {
  checked: boolean;
  label: string;
  onChange: (checked: boolean) => void;
  className?: string;
};

export default function ConsentToggle({
  checked,
  label,
  onChange,
  className,
}: Props) {
  return (
    <div className={clsx(className, 'flex items-center gap-3')}>
      <SwitchButton
        checked={checked}
        onChange={(_, value) => { onChange(value); }}
        color="primary"
        classes={{ rootContainer: 'gap-3' }}
      />
      <span className="text-xs font-semibold text-gray-700 leading-5">
        {label}
      </span>
    </div>
  );
}
